var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Controller } from "react-hook-form";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import ValidationService from "../../../Services/Shared/Validation.service";
import MeetingRequestService from "../../../Services/MeetingRequest.service";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
import useUniqueId from "../../Hooks/useUniqueId";
const MeetingRequestAvailabilityStatusModal = (_a) => {
    var { serviceDeliveryLocations, onLocationSaved } = _a, modalProps = __rest(_a, ["serviceDeliveryLocations", "onLocationSaved"]);
    const makeId = useUniqueId()[1];
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Select A Location", handleSubmit: ({ location }) => MeetingRequestService.saveMeetingRequestAvailabilityStatus(true, location.id).then(() => {
            if (onLocationSaved) {
                onLocationSaved(location);
            }
        }), children: (formValues) => {
            var _a;
            return (_jsxs(_Fragment, { children: [_jsx("p", { children: "You have more than one Department Location assigned for walk-in services. Select the location from which you would like to provide walk-ins." }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("location"), children: "Location" }), _jsx(Controller, { id: makeId("location"), name: "location", control: formValues.control, rules: { required: "Please select a location" }, as: _jsx(DeprecatedSelect, { className: ValidationService.makeClassName(formValues.errors, "location"), valueKey: "id", valueRenderer: (option) => `${option.location.name} ${option.name}`, optionRenderer: (option) => `${option.location.name} ${option.name}`, options: serviceDeliveryLocations }) }), _jsx("div", { className: "invalid-feedback", children: ((_a = formValues.errors) === null || _a === void 0 ? void 0 : _a.location) || "" })] })] }));
        } })));
};
export default MeetingRequestAvailabilityStatusModal;
